module.exports = __webpack_public_path__ + "static/media/icon_contact.5e30be54.svg";